import api from "../api";

const getDefaultState = () => ({
    modalShown: false,
    originalPassword: null,
    newPassword: null,
    newPasswordConfirmed: null,
});

export const passwordManager = {
    namespaced: true,

    state: getDefaultState(),

    getters: {

        inputIsValid(state) {
            return state.newPassword &&
                state.newPassword.trim().length >= 8 &&
                state.newPasswordConfirmed &&
                state.newPassword == state.newPasswordConfirmed &&
                state.originalPassword &&
                state.newPassword.trim() != state.originalPassword.trim();
        }

    },

    mutations: {
        setModalShown(state, modalShown) {
            state.modalShown = modalShown;
        },
        setOriginalPassword(state, originalPassword) {
            state.originalPassword = originalPassword;
        },
        setNewPassword(state, newPassword) {
            state.newPassword = newPassword;
        },
        setNewPasswordConfirmed(state, newPasswordConfirmed) {
            state.newPasswordConfirmed = newPasswordConfirmed;
        },
        resetState(state) {
            Object.assign(state, getDefaultState());
        },
    },

    actions: {

        openModal({ commit }) {
            commit('setModalShown', true);
        },

        closeModal({ commit }) {
            commit('setModalShown', false);
        },

        reset({ commit }) {
            commit('setModalShown', false);
            commit('setOriginalPassword', null);
            commit('setNewPassword', null);
            commit('setNewPasswordConfirmed', null);
        },

        changePassword({ state, dispatch }) {
            api.changePassword(
                state.originalPassword,
                state.newPassword
            ).then(
                () => {
                    dispatch('message/success', { title: 'Success', content: 'change password successfully.' }, { root: true });
                    dispatch('reset');
                },
            )

        },

    }

};